export const environment = {
  production: false,
  appVersion: "v717demo2",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: true,
  apiUrl: "api",
};
